var cssVars = {
  load:function(){
    this.setImage("heroBG","homeBG.png");
    this.setImage("homeGraphic","homeGraphicOpacity.png");
    this.setImage("purpleBG","purpleBG.jpg");
  },
  set:function(name,value){
    document.documentElement.style.setProperty("--"+name,value);
  },
  setImage:function(name,value){
    document.documentElement.style.setProperty("--"+name,"url("+ELAJAX.images+value+")");
  }
}

window.addEventListener("DOMContentLoaded",()=>{
  cssVars.load();
})
